import{LocaleEnum}from'@models/DomainTypes';const isNonGermanLocale=locale=>Boolean(locale&&locale!==LocaleEnum.de);export default isNonGermanLocale;